/**
@format
@flow
*/

import * as React from 'react';
import { FormRow as KrispyFormRow } from '@krispy/forms/web';

type Props = $ReadOnly<{|
  /**
   * Height, if any
   * Default '55px'
   */
  height?: string,

  /**
   * Width, if any,
   * Default '100%'
   */
  width?: string,

  /**
   * Padding-bottom, if any
   * Default '45px'
   */
  paddingBottom?: string,

  /**
   * Content to pass in
   * */
  children: any,
|}>;

/**
 * A row wrapper to be used in forms
 */
export default function FormRow(props: Props): React$Node {
  return (
    <KrispyFormRow {...props} />
  );
}

FormRow.defaultProps = {
  height: '55px',
  width: '100%',
  paddingBottom: '32px',
};
